<template>
    <section class="container">
        <div class="row">
            <div class="kt-portlet col-12">
                <div class="kt-portlet__head">
                    <div class="kt-portlet__head-label">
                        <h3 class="kt-portlet__head-title">
                            Cambio de contraseña
                        </h3>
                    </div>
                    <div class="kt-portlet__head-toolbar">
                        <button class="btn btn-link" title="Atrás" v-on:click="atras"><i class="fa fa-arrow-left"></i></button>
                    </div>
                </div>
                <form class="kt-form" autocomplete="false"  @submit.prevent="validar" >
                    <fieldset class="kt-portlet__body" :disabled="false">
                        <div class="alert alert-custom shadow fade show" role="alert">
                            <div>
                                <b>Inicio de sesión</b>
                                <p>Tu nueva contraseña debe ser distinta a la anterior y debe tener mínimo 10 caractéres</p>
                            </div>
                        </div>
                        <div class="p-4">
                            <div class="form-group row">
                                <label class="col-md-3 col-sm-12 col-form-label" for="nuevac">
                                    <i class="fa fa-asterisk text-danger"></i>
                                    Nueva contraseña
                                </label>
                                <div class="col-md-9 col-sm-12">
                                    <input
                                            autocomplete="false"
                                            type="password"
                                            class="form-control"
                                            name="nueva contraseña"
                                            id="nuevac"
                                            v-validate="{required:true,min:10}"
                                            v-model="formulario.password"
                                            ref="contraseña"
                                    />
                                    <span class="form-text text-danger">{{ errors.first('nueva contraseña') }}</span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 col-sm-12 col-form-label" for="confirmarc">
                                    <i class="fa fa-asterisk text-danger"></i>
                                    Confirma contraseña
                                </label>
                                <div class="col-md-9 col-sm-12">
                                    <input
                                            autocomplete="false"
                                            type="password"
                                            class="form-control"
                                            name="confirmar contraseña"
                                            id="confirmarc"
                                            v-validate="{required:true,confirmed:'contraseña'}"
                                    />
                                    <span class="form-text text-danger">{{ errors.first('confirmar contraseña') }}</span>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <div class="kt-portlet__foot ">
                        <div class="kt-form__actions">
                            <div class="row">
                                <div class="col-md-3 col-sm-12"></div>
                                <div class="col-md-9 col-sm-12">
                                    <button
                                            type="submit"
                                            class="btn btn-brand btn-md btn-tall btn-wide kt-font-bold"
                                    >
                                        Cambiar contraseña
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>

<script>
    import {acceso} from "../../servicios";
    import _ from 'lodash';

    export default {
        name: "cambioContrasena",
        data:()=>({
            formulario:{
                password:null,
            },
            cargando:false,
        }),
        methods:{
            validar:function(){
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.cargando=true;
                        this.enviarDatos();
                    }else{
                        this.$toast.show(`Completa el formulario`);
                    }
                });
            },
            enviarDatos:_.debounce(function () {
                acceso.cambiarPws(this.formulario.password).then(()=>{
                    this.$router.go(-1);
                    this.cargando=false;
                    this.$toast.show(`Tu contraseña ha sido actualizada`);
                }).catch(()=>{
                    setTimeout(()=>{
                        this.cargando=false;
                    },8000);
                });
            },2000),
            atras:function(){
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>

</style>
